export const getSchoolHourState = (state: any) => state.schoolHour;
